import { useRouter } from 'next/navigation';

import { CollectionSubHeader, RibbonButton } from '@/components/atomic/atoms';
import {
  captureGTMEventCTAClick,
  GTM_EVENTS_CTA_NAME,
  PAGE_NAME
} from '@/lib/gtm';

const BottomHeader = () => (
  <div className='flex flex-row mt-4 Montserrat'>
    <div className='self-center leading-snug text-xl'>
      <div className='font-extrabold'>
        {`UAE's largest event services team with 20,000+ events enabled `}
      </div>
      <div>{`Whether it's a gala dinner or a wedding ceremony, and whether`}</div>
      <div>
        you need a venue or an artist, Hafla will help you get it with no
        stress.
      </div>
    </div>
  </div>
);

const WhyChooseHeader = ({
  title,
  subTitle,
  buttonText,
  buttonUrl,
  isOpenInSameTab
}) => {
  const Router = useRouter();
  return (
    <div className='flex flex-row justify-around'>
      <div>
        <CollectionSubHeader
          {...{
            title,
            subTitle,
            underline: true,
            titleClass:
              'font-google-basic flex flex-row uppercase tracking-widest font-medium'
          }}
        />
        <BottomHeader />
      </div>
      <div className='flex flex-row self-start mt-3'>
        <RibbonButton
          buttonText={buttonText}
          onClick={() => {
            captureGTMEventCTAClick({
              ctaName: GTM_EVENTS_CTA_NAME.PLAN_YOUR_EVENT,
              pageName: PAGE_NAME.HOME_PAGE.label
            });
            return isOpenInSameTab
              ? Router.push(buttonUrl)
              : window.open(buttonUrl, '_blank');
          }}
        />
      </div>
    </div>
  );
};

export default WhyChooseHeader;
